import { styled } from 'styled-components'

export const TeamMemberCopyWrapper = styled.div`
    width: 100%;
    padding-top: ${props => `${props.theme.paddingXS}px`};
    margin-bottom: ${props => `${props.theme.marginXS}px`};
    border-top: solid 1px ${props => props.theme.colorBorderSecondary};
    border-bottom: solid 1px ${props => props.theme.colorBorderSecondary};
`
